import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Nav, Tab } from 'react-bootstrap';

export default function OrderApp() {
  return (
    <>
      <section className="order-app-area">
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <div className="container">
            <div className="row justify-content-between align-items-center">
              <div className="col-lg-12">
                <div className="order-app-header">
                  <h2 className="heading center-heading"><span className="gradiant-color">Custom Ordering</span>  Apps <br /> for Web & Mobile</h2>
                  <p className="sub-heading">Create Restaurant Mobile Apps & Website for your Customers</p>
                </div>
              </div>

              <div className="col-lg-6 col-md-6">
                <div className="orderapp-img-container">

                  <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <img loading="lazy" src="./assets/home/order-app-img1.webp" alt="notify" className="img-responsive notification-img" />
                    </Tab.Pane>

                    <Tab.Pane eventKey="second">
                      <img loading="lazy" src="./assets/home/order-app-img2.webp" alt="notify" className="img-responsive notification-img" />
                    </Tab.Pane>

                    <Tab.Pane eventKey="third">
                      <img loading="lazy" src="./assets/home/order-app-img.webp" alt="notify" className="img-responsive notification-img" />
                    </Tab.Pane>

                    <Tab.Pane eventKey="fourth">
                      <img loading="lazy" src="./assets/home/order-app-img4.webp" alt="notify" className="img-responsive notification-img" />
                    </Tab.Pane>

                    <Tab.Pane eventKey="fifth">
                      <img loading="lazy" src="./assets/home/order-app-img5.webp" alt="notify" className="img-responsive notification-img" />
                    </Tab.Pane>
                  </Tab.Content>

                  <img loading="lazy" src="./assets/home/orderapp-orange-blush.webp" alt="vector" className="img-responsive orange-blush" />
                  <img loading="lazy" src="./assets/home/orderapp-aqua-blush.webp" alt="vector" className="img-responsive aqua-blush" />
                </div>
              </div>

              <div className="col-lg-5 col-md-6">
                <div className="orderapp-tabs">
                  <Nav variant="pills" className="flex-column">
                    <Nav.Item>
                      <Nav.Link eventKey="first">
                        <div className="orderapp-tabs-wrap">
                          <div>
                            <h3>Restaurant Profile</h3>
                            <span><FontAwesomeIcon icon={faArrowDown}/></span>
                          </div>
                          <p>Present your restaurant’s location, menu, and reviews in detail to build credibility and engage customers seamlessly.</p>
                        </div>
                      </Nav.Link>
                    </Nav.Item>
                    
                    <Nav.Item>
                      <Nav.Link eventKey="second">
                        <div className="orderapp-tabs-wrap">
                          <div>
                            <h3>Search By Category</h3>
                            <span><FontAwesomeIcon icon={faArrowDown}/></span>
                          </div>
                          <p>Offer quick and convenient navigation with categorized searches, ensuring an intuitive user experience.</p>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link eventKey="third">
                        <div className="orderapp-tabs-wrap">
                          <div>
                            <h3>Push Notifications</h3>
                            <span><FontAwesomeIcon icon={faArrowDown}/></span>
                          </div>
                          <p>Keep users informed with real-time order updates, promotional alerts, and personalized messages to boost engagement.</p>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link eventKey="fourth">
                        <div className="orderapp-tabs-wrap">
                          <div>
                            <h3>Customer Support</h3>
                            <span><FontAwesomeIcon icon={faArrowDown}/></span>
                          </div>
                          <p>Deliver excellent service with instant assistance through a responsive customer support feature.</p>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                      <Nav.Link eventKey="fifth">
                        <div className="orderapp-tabs-wrap">
                          <div>
                            <h3>App Wallet</h3>
                            <span><FontAwesomeIcon icon={faArrowDown}/></span>
                          </div>
                          <p>Provide a secure and efficient way for customers to make transactions, ensuring a smooth payment experience.</p>
                        </div>
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
              </div>
            </div>
          </div>
        </Tab.Container>
      </section>
    </>
  )
}
